import React from "react";
import {
  Home,
  Map,
  MessageSquare,
  UserRound,
  Plus,
} from "lucide-react";

interface BottomNavProps {
  active?: string;
  onNavigate?: (page: string) => void;
  onCreate?: () => void;
}

const navItems = [
  {
    id: "home",
    label: "Home",
    icon: Home,
  },
  {
    id: "map",
    label: "Map",
    icon: Map,
  },
  {
    id: "messages",
    label: "Messages",
    icon: MessageSquare,
  },
  {
    id: "profile",
    label: "Profile",
    icon: UserRound,
  },
];

export default function BottomNav({
  active = "home",
  onNavigate = () => {},
  onCreate = () => {},
}: BottomNavProps) {
  const leftItems = navItems.slice(0, 2);
  const rightItems = navItems.slice(2);

  const renderItem = (item: typeof navItems[0]) => {
    const Icon = item.icon;
    const isActive = active === item.id || (item.id === "map" && active === "find");

    return (
      <button
        key={item.id}
        type="button"
        className={`bottom-nav__item ${
          isActive ? "bottom-nav__item--active" : ""
        }`}
        onClick={() => onNavigate(item.id === "map" ? "find" : item.id)}
        aria-label={item.label}
        aria-current={isActive ? "page" : undefined}
      >
        <Icon
          className="bottom-nav__icon"
          strokeWidth={isActive ? 2.6 : 2}
        />

        <span className="bottom-nav__label">
          {item.label}
        </span>
      </button>
    );
  };

  return (
    <nav className="bottom-nav" aria-label="Main navigation">
      {/* LEFT */}
      <div className="bottom-nav__group bottom-nav__group--left">
        {leftItems.map(renderItem)}
      </div>

      {/* CENTER ACTION */}
      <div className="bottom-nav__center">
        <button
          type="button"
          id="tour-nav-create"
          data-tour="create"
          className="bottom-nav__create"
          onClick={onCreate}
          aria-label="Create Game"
        >
          <Plus className="bottom-nav__plus" strokeWidth={2.4} />
        </button>
      </div>

      {/* RIGHT */}
      <div className="bottom-nav__group bottom-nav__group--right">
        {rightItems.map(renderItem)}
      </div>
    </nav>
  );
}
